import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { Cliente } from "@/shared/types/cliente";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export async function deleteCliente(id: string): Promise<Cliente> {
    await sleep(1000);
    const response = await api.delete("clientes/" + id);
    return response.data;
}

export function useDeleteClienteMutation(id: string, mutationConfig: MutationConfig<Cliente> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async () => await deleteCliente(id),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["clientes"] });
        },
    })
}

export interface DeleteClienteMutationProps{
    id: string, 
    mutationConfig?: MutationConfig<Cliente>,
    children?:(mutationResult:MutationResult<Cliente>)=>ReactNode
}

export function DeleteClienteMutation({
    id,
    children,
    mutationConfig
}:DeleteClienteMutationProps){
    const mutationResult = useDeleteClienteMutation(id, mutationConfig);
    return children&&children(mutationResult)
}